import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_CHILD_OF,
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_MEMBER,
  RELATION_MEMBER_OF,
  RELATION_OWNED_BY,
  RELATION_OWNER_OF,
  RELATION_PARENT_OF,
  RELATION_PROVIDES_API,
} from '@backstage/catalog-model';
import {
  RELATION_BUILD_DEPENDENCY_OF,
  RELATION_BUILD_DEPENDS_ON,
  RELATION_DEPLOY_DEPENDENCY_OF,
  RELATION_DEPLOY_DEPENDS_ON,
  RELATION_RUNTIME_DEPENDENCY_OF,
  RELATION_RUNTIME_DEPENDS_ON,
  softwareRelations,
} from 'backstage-plugin-neo4j-software-catalogue-common';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';

export const catalogGraphModule = createFrontendModule({
  pluginId: catalogGraphPlugin.pluginId,
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/catalog-graph',
        noHeader: true,
        routeRef: catalogGraphPlugin.routes.catalogGraph,
        loader: async () => {
          const { CatalogGraphPage, Direction, ALL_RELATION_PAIRS } =
            await import('@backstage/plugin-catalog-graph');
          return (
            <CatalogGraphPage
              initialState={{
                selectedRelations: [
                  RELATION_API_CONSUMED_BY,
                  RELATION_API_PROVIDED_BY,
                  RELATION_BUILD_DEPENDENCY_OF,
                  RELATION_BUILD_DEPENDS_ON,
                  RELATION_DEPLOY_DEPENDENCY_OF,
                  RELATION_DEPLOY_DEPENDS_ON,
                  RELATION_RUNTIME_DEPENDENCY_OF,
                  RELATION_RUNTIME_DEPENDS_ON,
                  RELATION_DEPENDENCY_OF,
                  RELATION_DEPENDS_ON,
                  RELATION_CONSUMES_API,
                  RELATION_PROVIDES_API,
                  RELATION_HAS_MEMBER,
                  RELATION_MEMBER_OF,
                  RELATION_OWNED_BY,
                  RELATION_OWNER_OF,
                  RELATION_CHILD_OF,
                  RELATION_PARENT_OF,
                ],
                direction: Direction.LEFT_RIGHT,
                mergeRelations: false,
                unidirectional: true,
              }}
              showArrowHeads
              zoom="enabled"
              relationPairs={[...ALL_RELATION_PAIRS, ...softwareRelations]}
            />
          );
        },
      },
    }),
  ],
});
